import FormattedMessage from 'I18n/components/FormattedMessage';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { Button } from 'foundations-components/transitional/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
const CrmTemplateBanner = ({
  ['data-test-id']: dataTestId,
  onClick
}) => {
  return /*#__PURE__*/_jsx(Alert, {
    "data-test-id": dataTestId,
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "setup-guide-components.crmTemplateBanner.heading"
    }),
    type: "tip",
    children: /*#__PURE__*/_jsx(Button, {
      onClick: onClick,
      use: "link",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "setup-guide-components.crmTemplateBanner.cta"
      })
    })
  });
};
export default CrmTemplateBanner;